import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing translations
import { cs } from '../locales/cs';
import { de } from '../locales/de';
import { en } from '../locales/en';
import { es } from '../locales/es';
import { fr } from '../locales/fr';
import { hr } from '../locales/hr';
import { hu } from '../locales/hu';
import { it } from '../locales/it';
import { nl } from '../locales/nl';
import { pl } from '../locales/pl';
import { ru } from '../locales/ru';
import { sk } from '../locales/sk';
import { tr } from '../locales/tr';
import { uk } from '../locales/uk';
// Importing store
import { usePlayerStore } from '../store/player.store';
// Importing 3rd party dependencies
import * as React from 'react';
import { use } from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------
use(initReactI18next)
    .init({
    ns: Object.keys(en),
    defaultNS: 'common',
    fallbackNS: 'common',
    fallbackLng: 'en',
    resources: {
        cs,
        de,
        en,
        es,
        fr,
        hr,
        hu,
        it,
        nl,
        pl,
        ru,
        sk,
        tr,
        uk,
    },
})
    .catch((error) => {
    console.log(`Error while initializing I18nProvider: ${error}`);
});
/**
 * I18nProvider component that sets up the i18next provider for the application.
 * Changes the language based on the locale from the player store.
 *
 * @param {I18nProviderProps} props - The props for the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the provider.
 * @returns {React.JSX.Element} The wrapped child components.
 */
export function I18nProvider({ children }) {
    const { i18n } = useTranslation();
    // Initializing player store
    const { locale } = usePlayerStore(useShallow((state) => ({
        locale: state.locale,
    })));
    React.useEffect(() => {
        i18n.changeLanguage(locale).catch(() => {
            console.log(`Error while changing language to ${locale}`);
        });
    }, [i18n, locale]);
    return _jsx(React.Fragment, { children: children });
}
